<main class="d-flex flex-row min-h-full align-items-stretch">
  <div class="flex-1 bg-center bg-cover bg-no-repeat d-none d-md-block"></div>
  <div class="d-flex flex-column flex-1 align-items-center justify-content-center p-3">
    <div class="d-flex flex-column flex-1 align-items-center justify-content-center w-100">
      <div class="login-container p-5 d-flex flex-column align-items-center justify-content-center">
        <div class="d-flex flex-row">
          <img src="../../../assets/clear_logo.png" width="125px" />
          <cmg-clear2-ui-version-number />
        </div>
        <p-button (click)="login()" label="Start Sign In" class="w-100 mt-4" styleClass="w-100" />
      </div>
    </div>
    <cmg-clear2-ui-login-footer />
  </div>
</main>
